import { render } from "./DraggableItems.vue?vue&type=template&id=48d5fd3c&scoped=true"
import script from "./DraggableItems.vue?vue&type=script&lang=js"
export * from "./DraggableItems.vue?vue&type=script&lang=js"

import "./DraggableItems.vue?vue&type=style&index=0&id=48d5fd3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d5fd3c"]])

export default __exports__